import { Site } from '@modules/modules/_contracts';
export const logoRegistry = {
    [Site.CyberDefence24]: require('./img/cyberdefence-24.svg'),
    [Site.Defence24]: require('./img/defence-24.svg'),
    [Site.Defence24COM]: '',
    [Site.Defence24MSPO]: require('./img/defence-24.svg'),
    [Site.Energetyka24]: require('./img/energetyka-24.svg'),
    [Site.InfoSecurity24]: require('./img/infosecurity-24.svg'),
    [Site.Space24]: require('./img/space-24.svg'),
    [Site.KadeciRP]: '' // todo
};
